import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const formatDate = (s) => s ? new Date(s).toLocaleString('en-ZA') : '—';

const outcome = (w) => {
  if (w.failureReason) return { label: 'Failed', color: '#e74c3c' };
  if (w.processed) return { label: 'Processed', color: '#27ae60' };
  if (w.verified) return { label: 'Received', color: '#e67e22' };
  return { label: 'Unverified', color: '#95a5a6' };
};

const CallbacksPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [open, setOpen] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/admin/webhooks', { params: { provider: 'TRADESAFE' } });
      setLogs(res.data || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load callbacks.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h2 style={{ margin: 0 }}>Payment Callbacks</h2>
          <p style={{ margin: '4px 0 0', color: '#7f8c8d', fontSize: '13px' }}>
            The 100 most recent payment notifications TradeSafe sent to the server. If a buyer paid but
            nothing shows here, the callback URL in the TradeSafe portal is wrong.
          </p>
        </div>
        <button onClick={load} style={{ padding: '8px 16px', cursor: 'pointer' }}>Refresh</button>
      </div>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {loading ? (
        <p>Loading...</p>
      ) : logs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#666', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
          <p style={{ fontSize: '18px' }}>No callbacks recorded</p>
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={th}>Received</th>
              <th style={th}>Provider</th>
              <th style={th}>Order</th>
              <th style={th}>Outcome</th>
              <th style={th}>Error</th>
              <th style={th}></th>
            </tr>
          </thead>
          <tbody>
            {logs.map(w => {
              const o = outcome(w);
              return (
                <React.Fragment key={w.id}>
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <td style={td}>{formatDate(w.createdAt)}</td>
                    <td style={td}>{w.provider}<br /><span style={muted}>{w.endpointPath}</span></td>
                    <td style={td}>{w.orderNumber || '—'}</td>
                    <td style={td}><span style={{ ...pill, backgroundColor: o.color }}>{o.label}</span></td>
                    <td style={{ ...td, color: '#c0392b', maxWidth: '320px', wordBreak: 'break-word' }}>{w.failureReason || ''}</td>
                    <td style={td}>
                      <button onClick={() => setOpen(open === w.id ? null : w.id)} style={{ ...btn, backgroundColor: '#ecf0f1' }}>
                        {open === w.id ? 'Hide' : 'Payload'}
                      </button>
                    </td>
                  </tr>
                  {open === w.id && (
                    <tr>
                      <td colSpan={6} style={{ ...td, backgroundColor: '#fafafa' }}>
                        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: '12px' }}>{w.payload}</pre>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

const th = { padding: '10px 12px', textAlign: 'left', fontWeight: '600', borderBottom: '2px solid #ddd' };
const td = { padding: '10px 12px', verticalAlign: 'top' };
const muted = { color: '#888', fontSize: '12px' };
const pill = { display: 'inline-block', color: '#fff', borderRadius: '10px', padding: '2px 8px', fontSize: '11px', fontWeight: 600 };
const btn = { padding: '4px 10px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' };

export default CallbacksPage;
